import React from 'react'
import Collapse, { Panel } from '../../components/shared/Collapse'
import { CameraIcon } from '@heroicons/react/solid'
import Icon from '../../components/icons/Icon'
import { iconType } from '../../types'
import { ReactSVG } from 'react-svg'
import useSearchDomains from '../../hooks/useSearchDomains'
import { apiEndPointProd, apiEndPointStaging, instantlogin } from '../../services/api'
import { fetchInt } from '../../services/fetchInt'
import { message } from 'antd'
type Props = {
    type:string, title:string, description:string|
    any, website?:string,linkedin?:string, country?:string, active:boolean, width?:string, maxLines?:string, maxLinesName?:string, actions:{website:boolean, chat:boolean, card:boolean, linkedin?:boolean}
}
type IProps = {
    link?:string,
    icon:string
}
function IconAction({link, icon}:IProps) {
  return (
    <>
        {link ? (
            <a className='p-1 rounded bg-hover-transparent !text-inherit' href={link} target='_blank' rel="noopener noreferrer">
                <Icon name={icon} className='icon-mini'/>
            </a>

        ) : (
            <button className='p-1 rounded bg-hover-transparent !text-inherit disabled:opacity-30' disabled>
            <Icon name={icon} className='icon-mini'/>
            </button>
        )}
    </>
  )
}

function CardActions({children}:{children:any}) {
    return (
      <div className='flex space-x-1.5 mt-2.5 -ml-1'>    
          {children}
      </div>
    )
  }
function Description({type, title, description, website, country, active, width, maxLines, maxLinesName, actions, linkedin}:Props) {
    return (
      <div className={`${width ?? 'w-[165px]'} py-1 pr-1.5 leading-[19px] flex flex-col`}>
        <div className='flex-1'>
          <div className='flex space-x-2 items-center'>
              <p className={`text-muted text-[12px]`}>{type} {country}</p>
  
          </div>
            <p className={`font-bold ${maxLinesName && maxLinesName}`}>{title}</p>
            <p className={`${maxLines ?? 'ellipsis-4'}   ${active? 'text-inherit text-small' : 'text-muted '}`}>{description}</p>
  
        </div>
          <CardActions>
            <>
            {actions.website && (
              <IconAction link={website} icon='OpenWindow'/>
  
            )}
            {actions.linkedin && (
              <IconAction link={linkedin} icon='Linkedin'/>
  
            )}
            {actions.chat && (
              <IconAction  icon='Chat'/>
  
            )}
            {actions.card && (
              <IconAction  icon='Chat'/>
  
            )}
            
            </>
  
          </CardActions>
               
  
       
          </div>
    )
  }
  type CProps = {
    active :boolean,
    icon:iconType,
    name:string,
    description:string,
    onClick:() => void,
    link?:any,
    width?:{
        description?:string,
        picture?:string
    },
    maxLinesName?:string,
    horizontale?:boolean,
    maxLinesDescription?:string
}
const CardComponent = ({active, icon, name, description, onClick, link, width, maxLinesName, horizontale, maxLinesDescription}:CProps) => {
    return(
        <div className={` ${active ? 'bg-skin-fill-inverted text-skin-inverted' : 'bg-hover-transparent'} pb-1 rounded ${!horizontale ? 'flex space-x-1' : ''}  w-max  cursor-pointer pr-2 group `} onClick={onClick}>
            <div className={`${active && 'bg-skin-fill-inverted text-skin-inverted'} h-max relative show-icon w-max rounded-[3px] overflow-hidden`}>
      
                <div>
                    <div className={`relative w-full p-[13px] h-max `}>
              
                        {icon && (
                            <div className={`relative   ${width?.picture ?? '!h-[100px] !w-[150px]'} rounded overflow-hidden max-[580px]:!w-[80px] max-[580px]:!h-[80px]`}>
                                {icon.type === 'image' && icon.src ? (
                                    <div className='border border-main p-1 bg-white rounded h-full'>
                                        <div className='border border-main rounded overflow-hidden h-full'>
                                            <img src={icon.src} className='w-full h-full object-cover ' alt="" />

                                        </div>

                                    </div>

                                ):(
                                    <div className={`w-full h-full border border-main rounded flex justify-center items-center ${active && 'bg-white'} group-hover:bg-white`}>
                                        <CameraIcon className={`w-[35px] h-[35px] ${active ? 'opacity-60' : 'opacity-[0.05]'}  `} />
                                    </div>
                                )}
                            </div>

                        )}
          
                    </div>
                </div>
            </div>
                
             <div className={`mt-1.5 ${horizontale ? 'mx-3 mt-0' : ''}`}>
                    <Description
                    title={name}
                    maxLinesName={maxLinesName}
                    maxLines={maxLinesDescription??'ellipsis-3'}
                    description={description}
                    width={width?.description}
                    type=''
                    active={!!active}
                    actions={{website:false, chat:false, card:false}}
                    />
                    {link ? (
                        link

                    ): (
                        <></>
                    )}
                        

             </div>
        
                
              
              </div> 
    )
}
export default function Layout() {
    const {domains} = useSearchDomains({filterBy: `popular:true`, query: '*'})

    const handleGenerateToken = async ({type}:{type:'staging'|'prod'}) => {
        let url = apiEndPointProd
     
        if(!url) return
        const req = await fetch(instantlogin(url), {
            method: 'POST',
            headers: { 
                "Content-Type": "application/json", 
                "Access-Control-Allow-Credentials": "true", 
            },
            credentials: "include",
            body: JSON.stringify({
                "destination": type 
            })
        })
        const res = await req.json()
        if(!res.data){
            message.error('Error generating token')
        }
        return res.data

    }

    const handleOpen = async(path:string, type:'staging'|'prod') => {
        const token = await handleGenerateToken({type})
        if(token){
            window.open(`${path}?token=${token}`)
        }

    }

  return (
    <div>
        <div className="bar-h px-5 flex items-center border-b border-main space-x-3 ">
            <ReactSVG src='https://firebasestorage.googleapis.com/v0/b/qorddu-production.firebasestorage.app/o/logo_symbol.svg?alt=media&token=c5969d32-3d07-44f3-8117-1c5fdb7473ec' className='icon-md'/>
            <p className="font-bold">Qorddu central page</p>
        </div>
        <div className="px-5 pt-8">
            <Collapse defaultActiveKey={['1']} >
             <>
                <Panel header={<p className='text-groupe'>Pour la demo</p>} key={'1'}>
                    <div className="flex gap-4 flex-wrap pl-3">
                        <CardComponent
                        
                            active={false}
                            icon={{type:'icon', src:''}}
                            name='Local economy - Abu Dhabi'
                            description='Serveur en preparation'
                            onClick={() => handleOpen('https://local-economy-demo.qorddu.com/en/98f8bbf5-e0b5-418b-97d4-cb407f7282c9/RegionalServers/33af7fda-e96c-4c2c-8ae9-83396337babe', 'staging')}

                        />

                    </div>
                </Panel>
                <Panel header={<p className='text-groupe'>Les domains en preparation</p>} key={'2'}>
                    <div className="flex gap-4 flex-wrap pl-3">
                        {domains?.map((item) => (
                            <CardComponent
                            
                                active={false}
                                icon={{type:'image', src:item.document.image??''}}
                                name={item.document.title.en}
                                description={item.document.description.en ?? 'Description not available'}
                                onClick={() => handleOpen(`https://${item.document.title.en.toLocaleLowerCase().split(' ').join('-')}.qorddu.com`, 'prod')}
                                // link={<a href={item.document.website} target='_blank' rel="noopener noreferrer" className='text-main'>Open</a>}
                            />
                        ))}
                    

                    </div>
                </Panel>
                <Panel header={<p className='text-groupe'>Les serveurs activées</p>} key={'3'}>
                    <div className="flex gap-4 flex-wrap pl-3">
                        <CardComponent
                        
                            active={false}
                            icon={{type:'image', src:''}}
                            name='Groupe 1'
                            description='Description of the groupe 1'
                            onClick={() => console.log('click')}

                        />

                    </div>
                </Panel>
                <Panel header={<p className='text-groupe'>Resources</p>} key={'4'}>
                    <div className="flex gap-4 flex-wrap pl-3">
                        <CardComponent
                        
                            active={false}
                            icon={{type:'image', src:''}}
                            name='Partners pages'
                            description=''
                            onClick={() => handleOpen('https://qorddu.com/home/fr', 'prod')}

                        />

                    </div>
                </Panel>
             </>
            </Collapse>
        </div>
    </div>
  )
}
